

import Vue from 'vue';
import {AlertPlugin, ConfirmPlugin, PromptPlugin, LoadingPlugin, NotifyPlugin, ToastPlugin} from '@/plugins';
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'


import App from './App';
import router from './router';
import store from './store';
import FastClick from "fastclick";

import './utils/directives';
import './utils/filters';




Vue.use(AlertPlugin);
Vue.use(ConfirmPlugin);
Vue.use(PromptPlugin);
Vue.use(LoadingPlugin);
Vue.use(NotifyPlugin);
Vue.use(ToastPlugin);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(ViewBox);
Vue.use(XHeader);
Vue.use(Scroller);
/* eslint-disable no-new */

window.onload = function () {
FastClick.attach(document.body);
}
new Vue({
el: '#app',
router,
store,
render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js